import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import Ad from '@ifeng-fe/ui_pc_ad';
import Header from './header/';
import Footer from './footer';
import SubHead from './subHead';
import Content from './content';
import ToTop from '../component/toTop';
import NoSSR from 'react-no-ssr';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    render() {
        const { content } = this.props;
        const {
            vSource,
            docData,
            nav,
            footer,
            search,
            navData,
            hotTopics,
            rankingList,
            relatedVideos,
            videoStream,
            allVideoStream,
            parentColumn,
            wemediaEAccountId,
            fhhAccountDetail, // 大风号作者信息
            bookRecommendData,
            audioTopics,
            // 广告
            bannertopAd,
            streamListAd,
            bannerAd01,
            rectangleAd01,
            bannerAd02,
            picAndTxt,
            bannerAd03,
            rectangleAd02,
            rectangleAd03,
            hotTopicsAd,
            playerUtils,
            keywords,
            hasRelatedRecommend,
            safeLevel,
            isCloseAlgRec,
            interact,
            pageTopAd,
            pageBottomAd,
            hotRecommond,
        } = content;
        const isHitBlack = safeLevel === 1;
        const headerData = {
            nav,
        };
        const contentData = {
            vSource,
            hotTopics,
            rankingList,
            relatedVideos,
            videoStream,
            allVideoStream,
            parentColumn,
            wemediaEAccountId,
            fhhAccountDetail,
            bookRecommendData,
            audioTopics,
            playerUtils,
            isHitBlack,
            hasRelatedRecommend,
            isCloseAlgRec,
            interact,
            hotRecommond,
        };
        const contentAd = {
            bannertopAd,
            streamListAd,
            bannerAd01,
            rectangleAd01,
            bannerAd02,
            picAndTxt,
            bannerAd03,
            rectangleAd02,
            rectangleAd03,
            hotTopicsAd,
        };

        return (
            <React.Fragment>
                <Header content={headerData} />
                <div className={styles.col_1230}>
                    <NoSSR>
                        <Ad content={pageTopAd} />
                    </NoSSR>
                </div>
                <SubHead search={search} navData={navData} />
                <Content content={contentData} docData={docData} ad={contentAd} />
                <div className={styles.col_1230}>
                    <NoSSR>
                        <Ad content={pageBottomAd} />
                    </NoSSR>
                </div>
                <Footer content={footer} />
                <NoSSR>
                    <ToTop base62Id={docData?.base62Id} />
                </NoSSR>
                <ChipEdit transform={transform} />
            </React.Fragment>
        );
    }
}

export default Layout;
